import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, ApiError } from '../lib/api';
import type { Me } from '../lib/api';

/** Shown instead of the app when the account carries a temporary password. */
export function PasswordChange({ me, onDone, onLogout }: { me: Me; onDone: () => void; onLogout: () => void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    if (next !== confirm) { setErr('The new passwords do not match.'); return; }
    setBusy(true);
    try {
      await api('/api/auth/password', { method: 'POST', json: { current, next } });
      onDone();
    } catch (ex) {
      setErr(ex instanceof ApiError && ex.status === 401 ? 'The temporary password is wrong.' : ex instanceof ApiError && ex.message === 'password_unchanged' ? 'Choose a different password.' : 'Could not change the password.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="brand">
          <div className="brand-mark">PX</div>
          <div className="brand-text"><div className="brand-title">PRAXIS</div><div className="brand-sub">Set your password</div></div>
        </div>
        <p className="muted" style={{ marginBottom: 14, fontSize: 13 }}>Welcome, {me.user.display_name}. Your account has a temporary password; choose your own before continuing.</p>
        <div className="field"><label htmlFor="pc-cur">Temporary password</label><input id="pc-cur" className="input" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} /></div>
        <div className="field"><label htmlFor="pc-next">New password (12+ characters)</label><input id="pc-next" className="input" type="password" autoComplete="new-password" required minLength={12} value={next} onChange={(e) => setNext(e.target.value)} /></div>
        <div className="field"><label htmlFor="pc-conf">Confirm new password</label><input id="pc-conf" className="input" type="password" autoComplete="new-password" required minLength={12} value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
        <button className="primary-btn" type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>{busy ? 'Saving…' : 'Save and continue'}</button>
        {err && <div className="error-text">{err}</div>}
        <div style={{ marginTop: 14, textAlign: 'center' }}><button type="button" className="link" style={{ background: 'none', border: 0, cursor: 'pointer' }} onClick={onLogout}>Sign out</button></div>
      </form>
    </div>
  );
}
